<template>
  <div class="skyway-wrapper">
    <div class="skyway-inner">
      <SkywayLoading v-if="loading" />
      <div class="shared-screen" v-show="!_.isEmpty(sharePeerId)">
        <video v-if="!shareStream.active" autoplay playsinline :srcObject.prop="_.findLast(skywayParticipants, {peerId: sharePeerId})" />
        <div class="message" v-else><span>あなたの画面を共有しています。</span></div>
      </div>
      <div class="skyway-participants" :class="[grid, {shareMode: !_.isEmpty(sharePeerId)}]">
        <div class="participant-window">
          <div class="video_inner">
            <video class="mirror" autoplay muted playsinline :srcObject.prop="selfStream" />
            <span class="participant-name">
              {{ user.name }}
              <span class="participant-status" v-if="!enableCamera || audioOnly">
                <fa-icon icon="video-slash" />
              </span>
              <span class="participant-status" v-if="!enableMic">
                <fa-icon icon="microphone-slash" />
              </span>
            </span>
          </div>
        </div>
        <!-- ToDo 9人を超えた分について、何人いるかを表示 https://valeur.backlog.jp/view/YOSHIDA_VIRTUAL-221-->
        <div
          class="participant-window"
          v-for="(participant, key) in _.reject(skywayParticipants, {peerId: sharePeerId})"
          :key="key"
          v-show="key <= 7"
        >
          <div class="video_inner">
            <video autoplay playsinline :srcObject.prop="participant" />
            <span class="participant-name" v-if="participant.user">
              {{ participant.user.name }}
              <span class="participant-status" v-if="!participant.user.status.camera">
                <fa-icon icon="video-slash" />
              </span>
              <span class="participant-status" v-if="!participant.user.status.mic">
                <fa-icon icon="microphone-slash" />
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="stream-setting">
      <div class="stream-setting-button extBtn_wrapper btn" @mouseover="mouseOverAction('exit')" @mouseleave="mouseLeaveAction('exit')">
        <transition name="fade">
          <div class="mouseOver-content inner" v-if="hoverFlags.exit && !$isMobile.any">
            <span>会場に戻ります</span>
          </div>
        </transition>
        <router-link
          :to="{name: 'Hall', params: {hallSlug: $route.params.hallSlug}}"
          class="ext_btn flex_center inner light"
          v-if="$route.params.roomSlug"
        >
          <div>
            <fa-icon icon="sign-out-alt" />
          </div>
          <div>退出</div>
        </router-link>
        <router-link :to="{name: 'Top', params: {slug: $route.params.slug}}" class="ext_btn flex_center" v-else>
          <div>
            <fa-icon icon="sign-out-alt" />
          </div>
          <div>退出</div>
        </router-link>
      </div>
      <div class="flex_center streamSetting_inner">
        <div
          v-if="enableMic"
          class="stream-setting-button btn"
          @click="setEnableMic(false)"
          @mouseover="mouseOverAction('sound')"
          @mouseleave="mouseLeaveAction('sound')"
          :class="{inactive: !micDeviceList.length || deviceNotAllowed}"
        >
          <transition name="fade">
            <div class="mouseOver-content inner" v-if="hoverFlags.sound && !$isMobile.any">
              <span>現在音声はONになっています。クリックするとOFFになります。</span>
            </div>
          </transition>
          <div class="inner light">
            <fa-icon icon="microphone" />
            <p>音声</p>
          </div>
        </div>
        <div
          v-else
          class="stream-setting-button off btn selected filter"
          @click="setEnableMic(true)"
          @mouseover="mouseOverAction('sound')"
          @mouseleave="mouseLeaveAction('sound')"
          :class="{inactive: !micDeviceList.length || deviceNotAllowed}"
        >
          <transition name="fade">
            <div class="mouseOver-content inner" v-if="hoverFlags.sound && !$isMobile.any">
              <span>現在音声はOFFになっています。クリックするとONになります。</span>
            </div>
          </transition>
          <div>
            <fa-icon icon="microphone-slash" />
            <p>音声</p>
          </div>
        </div>
        <div
          v-if="enableCamera"
          class="stream-setting-button btn"
          @click="setEnableCamera(false)"
          @mouseover="mouseOverAction('stream')"
          @mouseleave="mouseLeaveAction('stream')"
          :class="{inactive: !videoDeviceList.length || deviceNotAllowed}"
        >
          <transition name="fade">
            <div class="mouseOver-content inner" v-if="hoverFlags.stream && !$isMobile.any">
              <span>現在映像はONになっています。クリックするとOFFになります。</span>
            </div>
          </transition>
          <div class="inner light">
            <fa-icon icon="video" />
            <p>映像</p>
          </div>
        </div>
        <div
          v-else
          class="stream-setting-button off btn selected filter"
          @click="setEnableCamera(true)"
          @mouseover="mouseOverAction('stream')"
          @mouseleave="mouseLeaveAction('stream')"
          :class="{inactive: !videoDeviceList.length || deviceNotAllowed}"
        >
          <transition name="fade">
            <div class="mouseOver-content inner" v-if="hoverFlags.stream && !$isMobile.any">
              <span>現在映像はOFFになっています。クリックするとONになります。</span>
            </div>
          </transition>
          <div>
            <fa-icon icon="video-slash" />
            <p>映像</p>
          </div>
        </div>
      </div>
      <div class="flex_center" :style="{'justify-content': 'flex-end'}">
        <div class="screen-share wrapper" @click="forceDisableMic" @mouseover="mouseOverAction('mute')" @mouseleave="mouseLeaveAction('mute')">
          <transition name="fade">
            <div class="mouseOver-content inner" v-if="hoverFlags.mute && !$isMobile.any">
              <span>自分以外全員の音声をミュートします。</span>
            </div>
          </transition>
          <div class="arrow faa-pulse animated">
            <fa-icon icon="microphone-slash" />
          </div>
          <span>ミュート</span>
        </div>
        <div v-if="!$isMobile.any" :style="{display: 'contents'}">
          <div
            v-if="!sharing"
            class="screen-share wrapper"
            :class="{inactive: !_.isEmpty(sharePeerId)}"
            @click="sharing = true"
            @mouseover="mouseOverAction('share')"
            @mouseleave="mouseLeaveAction('share')"
          >
            <transition name="fade">
              <div class="mouseOver-content inner" v-if="hoverFlags.share">
                <span>画面の共有ができるようになります。<br />クリックして共有する画面を選択してください。</span>
              </div>
            </transition>
            <div>
              <fa-icon icon="share-square" />
            </div>
            <span>画面共有</span>
          </div>
          <div v-else class="screen-share sharing" @click="sharing = false">
            <div class="faa-pulse animated">
              <fa-icon icon="share-square" />
            </div>
            <span>共有停止</span>
          </div>
        </div>
        <div class="other-setting" @click="invertModalStatus">
          <fa-icon icon="exclamation-circle" class="notification-icon" v-if="!_.isEmpty(message)" />
          <fa-icon icon="ellipsis-v" />
        </div>
      </div>
    </div>
    <transition name="fade" v-if="showModal">
      <Modal @close="invertModalStatus">
        <div slot="content">
          <div class="deviceErrorMessage" v-if="message.device">
            <fa-icon icon="exclamation-circle" class="notification-icon" />
            <span v-html="message.device" />
          </div>
          <div class="deviceErrorMessage" v-if="message.stream">
            <fa-icon icon="exclamation-circle" class="notification-icon" />
            <span v-html="message.stream" />
          </div>
          <div class="device-setting">
            <h3>デバイスの設定</h3>
            <div class="device-item">
              <label for="camera-device">
                <fa-icon icon="video" />
                カメラ
              </label>
              <select id="camera-device" v-model="videoDeviceId">
                <option v-for="(device, key) in videoDeviceList" :value="device.deviceId" :key="key">{{ device.label }}</option>
              </select>
            </div>
            <div class="device-item">
              <label for="mic-device">
                <fa-icon icon="microphone" />
                マイク
              </label>
              <select id="mic-device" v-model="micDeviceId">
                <option v-for="(device, key) in micDeviceList" :value="device.deviceId" :key="key">{{ device.label }}</option>
              </select>
            </div>
          </div>
        </div>
      </Modal>
    </transition>
  </div>
</template>

<script>
import Peer from "skyway-js"
import Share from "../../skyway/entities/share.js"
import MicDisable from "../../skyway/entities/mic-disable.js"
import Lang from "../../skyway/lang.js"
import User from "../../skyway/entities/user.js"
import Modal from "../elements/Modal"
import SkywayLoading from "../elements/SkywayLoading"

const lifecycle = {
  _vm: undefined,
  values: {
    roomName: null,
    room: null,
    shareRoom: null,
    peer: null,
    screenPeer: null,
    participants: {},
    user: {
      userId: null,
      status: {
        camera: null,
        mic: null
      }
    }
  },
  start: async vue => {
    lifecycle._vm = vue

    // イベント開催中であることを監視
    lifecycle.events.eventExpire()

    await lifecycle.setValues()
    await lifecycle.init()
    await lifecycle.eventBind()
  },
  setValues: async () => {
    const env = lifecycle._vm.$config.app.env
    let roomName =
      lifecycle._vm.type === "mesh"
        ? `${lifecycle._vm.$route.params.slug}-${lifecycle._vm.$route.params.roomName}`
        : `${lifecycle._vm.$route.params.slug}-${lifecycle._vm.$route.params.roomSlug}`
    lifecycle.values.user.userId = lifecycle._vm.$store.getters["auth/id"]

    if (!env.includes("prod")) {
      roomName = `${env}-${roomName}`
    }

    lifecycle.values.roomName = roomName

    let credentialObject = await lifecycle._vm.$axios.post(`auth/${lifecycle._vm.$route.params.slug}/skyway`, {
      peerId: lifecycle.values.user.userId
    })

    await Promise.all([credentialObject])

    lifecycle.values.peer = new Peer({
      key: credentialObject.data.key,
      credential: credentialObject.data.credential
    })

    let count = 0
    const peerRetry = window.setInterval(() => {
      if (lifecycle.values.peer.open || count >= 5) {
        clearInterval(peerRetry)
        return
      }

      try {
        lifecycle.values.peer = new Peer({
          key: credentialObject.data.key,
          credential: credentialObject.data.credential
        })
      } catch (e) {
        console.error(e)
      }

      count++
      console.log(`peer try count ${count}`)
    }, 500)

    console.log("___setValues_after_peer___")
    console.log(lifecycle.values.peer)

    let screenCredentialObject = await lifecycle._vm.$axios.post(`auth/${lifecycle._vm.$route.params.slug}/skyway`, {
      peerId: `${lifecycle.values.user.userId}_screen`
    })

    lifecycle.values.screenPeer = new Peer({
      key: screenCredentialObject.data.key,
      credential: screenCredentialObject.data.credential
    })
  },
  init: async () => {
    await lifecycle.events.deviceSetUp()
    await lifecycle.events.getSelfStream()
    lifecycle.events.updateCamera()
    lifecycle.events.updateMic()
    lifecycle.events.join()
  },
  disconnect: () => {
    lifecycle.values.room.close()

    // ルーム情報を初期化
    lifecycle.values.room = null

    lifecycle._vm.selfStream.getTracks().forEach(track => {
      track.stop()
      track.enabled = false
    })
    lifecycle._vm.selfStream = null

    if (!_.isEmpty(lifecycle.values.shareRoom)) {
      lifecycle.values.shareRoom.close()
    }
    if (lifecycle._vm.shareStream instanceof MediaStream) {
      lifecycle._vm.shareStream.getTracks().forEach(track => {
        track.stop()
        track.enabled = false
      })
      lifecycle._vm.shareStream = null
    }
  },
  normal: () => {
    // 画面共有モードを終了し、通常モードへ移行
    lifecycle._vm.sharePeerId = null
    lifecycle._vm.sharing = false
    if (lifecycle.values.shareRoom) {
      lifecycle.values.shareRoom.close()
    }
    if (lifecycle._vm.shareStream) {
      lifecycle._vm.shareStream.getTracks().forEach(track => {
        track.stop()
      })
    }
  },
  share: () => {
    // 画面共有のPeer接続がSocket受信より先に開始していた場合
    lifecycle._vm.pickupStream = _.find(lifecycle._vm.skywayParticipants, {peerId: lifecycle._vm.sharePeerId}) || lifecycle._vm.pickupStream
  },
  eventBind: () => {
    try {
      lifecycle.values.room.on("stream", lifecycle.events.arrival)
      lifecycle.values.room.on("peerLeave", lifecycle.events.left)
      lifecycle.values.room.on("data", lifecycle.socketReceiver)
    } catch (e) {
      console.error(e)
      lifecycle._vm.$store.commit("requestReload/setDisconnected", true)
      lifecycle._vm.$store.commit("requestReload/setMessage", "Web会議システムへの接続に失敗しました。<br>画面を再読み込みしてください。")
    }
  },
  socketBroadcast: (value, room) => {
    room.send(value.toJson())
  },
  socketReceiver: message => {
    switch (message.data.class) {
      case "share":
        lifecycle.events.receiveShare(new Share(message.data), message.src)
        break
      case "mic-disable":
        lifecycle.events.disableMic(new MicDisable(message.data), message.src)
        break
      case "user":
        lifecycle.events.setUserStatus(new User(message.data.user), message.src)
        break
    }
  },
  events: {
    deviceSetUp: async () => {
      navigator.mediaDevices.addEventListener("devicechange", () => {
        lifecycle.events.getDeviceList()
      })
      await lifecycle.events.getDeviceList()
    },
    getDeviceList: async () => {
      const devices = await navigator.mediaDevices.enumerateDevices()

      lifecycle._vm.videoDeviceList = _.filter(devices, {kind: "videoinput"})
      lifecycle._vm.micDeviceList = _.filter(devices, {kind: "audioinput"})

      lifecycle.events.setAudioOnly()

      if (lifecycle._vm.audioOnly) {
        lifecycle.events.audioOnlyCameraAlert()
      } else {
        lifecycle.events.cameraAlert()
      }

      lifecycle.events.micAlert()

      // デバイスの存在チェック
      // 切断されていれば、デバイスリストの一番上をセット
      // オーディオのみで接続している場合はビデオデバイスの設定をスキップ

      if (!_.find(lifecycle._vm.videoDeviceList, {deviceId: lifecycle._vm.videoDeviceId}) && !lifecycle._vm.audioOnly) {
        lifecycle._vm.videoDeviceId = lifecycle._vm.videoDeviceList[0].deviceId
      }
      if (!_.find(lifecycle._vm.micDeviceList, {deviceId: lifecycle._vm.micDeviceId})) {
        lifecycle._vm.micDeviceId = lifecycle._vm.micDeviceList[0].deviceId
      }
    },
    setAudioOnly: () => {
      if (_.isNull(lifecycle._vm.audioOnly)) {
        lifecycle._vm.audioOnly = _.isEmpty(lifecycle._vm.videoDeviceList)
      }
      if (lifecycle._vm.audioOnly) {
        lifecycle._vm.message["stream"] = Lang.alert.audio_only()
      }
    },
    audioOnlyCameraAlert: () => {
      if (_.isEmpty(lifecycle._vm.videoDeviceList)) return

      lifecycle._vm.message["device"] = Lang.errors.general()
      lifecycle._vm.invertModalStatus()
    },
    cameraAlert: () => {
      if (!_.isEmpty(lifecycle._vm.videoDeviceList)) return

      lifecycle._vm.message["device"] = Lang.errors.general()
      lifecycle._vm.invertModalStatus()
    },
    micAlert: () => {
      if (!_.isEmpty(lifecycle._vm.micDeviceList)) return

      lifecycle._vm.message["device"] = Lang.errors.no_mic()
      lifecycle._vm.invertModalStatus()
    },
    changeDevice: async () => {
      // getUserMediaの解決前にwatcherから呼ばれた際のエラーを回避
      await Promise.all([lifecycle._vm.selfStream])

      lifecycle._vm.selfStream.getTracks().forEach(track => {
        track.stop()
      })

      console.log("____getUserMedia____")
      console.log(lifecycle._vm.selfStream)
      lifecycle._vm.selfStream = await navigator.mediaDevices.getUserMedia({
        video: {
          width: {ideal: 640},
          height: {ideal: 360},
          deviceId: lifecycle._vm.videoDeviceId
        },
        audio: {deviceId: lifecycle._vm.micDeviceId}
      })
      console.log(lifecycle._vm.selfStream)

      if (!_.isEmpty(lifecycle.values.room)) lifecycle.values.room.replaceStream(lifecycle._vm.selfStream)
      // カメラのON/OFFを反映
      lifecycle.events.updateCamera()
      lifecycle.events.updateMic()
    },
    updateCamera: () => {
      if (lifecycle._vm.audioOnly) return

      lifecycle._vm.selfStream.getVideoTracks().forEach(track => {
        track.enabled = lifecycle._vm.enableCamera
      })
      if (!_.isEmpty(lifecycle.values.room)) lifecycle.values.room.replaceStream(lifecycle._vm.selfStream)
      lifecycle.values.user.status.camera = lifecycle._vm.enableCamera
      if (lifecycle.values.room) lifecycle.socketBroadcast(new User(lifecycle.values.user), lifecycle.values.room)
    },
    updateMic: () => {
      lifecycle._vm.selfStream.getAudioTracks().forEach(track => {
        track.enabled = lifecycle._vm.enableMic
      })

      lifecycle.values.user.status.mic = lifecycle._vm.enableMic
      if (lifecycle.values.room) lifecycle.socketBroadcast(new User(lifecycle.values.user), lifecycle.values.room)
    },
    getSelfStream: async () => {
      const videoSetting = !lifecycle._vm.audioOnly
        ? {width: {ideal: 640}, height: {ideal: 360}, deviceId: lifecycle._vm.videoDeviceId}
        : !lifecycle._vm.audioOnly

      try {
        console.log("____getUserMedia____")
        console.log(lifecycle._vm.selfStream)
        lifecycle._vm.selfStream = await navigator.mediaDevices.getUserMedia({
          video: videoSetting,
          audio: {deviceId: lifecycle._vm.micDeviceId}
        })
        console.log(lifecycle._vm.selfStream)
      } catch (error) {
        if (error.message === "Permission denied") {
          lifecycle._vm.message["device"] = Lang.errors.permission_denied()
          lifecycle._vm.deviceNotAllowed = true
        } else {
          lifecycle._vm.message["stream"] = Lang.errors.general()
        }
        lifecycle._vm.invertModalStatus()
      }
    },
    join: () => {
      if (!lifecycle.values.peer.open) {
        console.log("peer connection is not opened")
        return
      }

      console.log("_____join_room_____")
      console.log(lifecycle._vm.type)
      console.log(lifecycle.values.peer)
      console.log(lifecycle._vm.selfStream)

      // ルームの設定を初期化
      let count = 0
      while (!lifecycle.values.room && count < 2) {
        try {
          lifecycle.values.room = lifecycle.values.peer.joinRoom(lifecycle.values.roomName, {
            mode: lifecycle._vm.type,
            stream: lifecycle._vm.selfStream
          })
        } catch (e) {
          console.error(e)
        }
        count++
      }

      console.log(lifecycle.values.room)

      // 画面表示用にuserIdを送信
      try {
        lifecycle.values.room.on("open", () => {
          lifecycle.socketBroadcast(new User(lifecycle.values.user), lifecycle.values.room)
          lifecycle._vm.loading = false
        })
      } catch (e) {
        console.error(e)
        lifecycle._vm.$store.commit("requestReload/setDisconnected", true)
        lifecycle._vm.$store.commit("requestReload/setMessage", "Web会議システムへの接続に失敗しました。<br>画面を再読み込みしてください。")
      }
    },
    arrival: function(stream) {
      // participantsに格納されているユーザー情報をstreamに格納
      const newStream = stream
      newStream.user = lifecycle.values.participants[newStream.peerId]
      lifecycle._vm.skywayParticipants.push(newStream)

      // 自身が画面共有中の場合、再度画面共有情報を送信
      if (!_.isEmpty(lifecycle.values.shareRoom)) {
        lifecycle.socketBroadcast(new Share(), lifecycle.values.shareRoom)
      }

      // 画面表示用にuserIdを送信
      lifecycle.socketBroadcast(new User(lifecycle.values.user), lifecycle.values.room)
    },
    left: function(peerId) {
      const leaveIndex = _.findIndex(lifecycle._vm.skywayParticipants, ["peerId", peerId])
      lifecycle._vm.skywayParticipants.splice(leaveIndex, 1)

      // 退出したPeerIdが画面共有であった場合は、画面共有モードを終了
      if (peerId === lifecycle._vm.sharePeerId) {
        lifecycle.normal()
      }

      if (lifecycle._vm.type === "mesh") lifecycle.events.setPickupStream()

      // 退出したPeerIdのユーザー情報を削除
      delete lifecycle.values.participants[peerId]
    },
    receiveShare: (share, peerId) => {
      lifecycle.share()
      lifecycle._vm.sharePeerId = peerId
    },
    startShare: () => {
      navigator.mediaDevices
        .getDisplayMedia({
          video: {
            height: {max: 640}
          },
          audio: true
        })
        .then(stream => {
          lifecycle._vm.shareStream = stream
          // 画面共有用のPeer通信を開く
          lifecycle.values.shareRoom = lifecycle.values.screenPeer.joinRoom(lifecycle.values.roomName, {
            mode: lifecycle._vm.type,
            stream: lifecycle._vm.shareStream
          })
          // WebSocketでデータを送信し、相手側の拡大表示を切り替える
          lifecycle.values.shareRoom.on("open", () => {
            lifecycle.socketBroadcast(new Share(), lifecycle.values.shareRoom)
          })
          // ブラウザ側で共有停止をした際、検知して正常に画面共有を終了する
          stream.getVideoTracks()[0].onended = () => {
            lifecycle._vm.sharing = false
          }
        })
        .catch(error => {
          lifecycle._vm.sharing = false
        })
    },
    setPickupStream: stream => {
      lifecycle._vm.pickupStream = _.isEmpty(stream) ? _.last(lifecycle._vm.skywayParticipants) : stream
    },
    disableMic: (micDisable, peerId) => {
      if (!lifecycle._vm.enableMic) return
      const user = lifecycle.values.participants[peerId]
      lifecycle._vm.$store.commit("stream/setEnableMic", false)
      window.setTimeout(function() {
        alert(user.name ? Lang.alert.muted(user.name) : Lang.alert.muted_by_undefined())
      }, 500)
    },
    setUserStatus: async (message, peerId) => {
      let user = lifecycle._vm.$store.getters["participants/getByUserId"](message.user.userId)
      user.status = message.user.status

      if (user) lifecycle.values.participants[peerId] = user
      const tempArray = []
      lifecycle._vm.skywayParticipants.forEach(stream => {
        const tempStream = stream
        tempStream.user = lifecycle.values.participants[stream.peerId]
        tempArray.push(tempStream)
      })
      lifecycle._vm.skywayParticipants = tempArray
    },
    eventExpire: () => {
      if (lifecycle._vm.$config.app.debug) return

      const event = lifecycle._vm.$store.getters["event/event"]
      const today = lifecycle._vm.$moment()

      const expireTimer = window.setInterval(() => {
        if (today.isBetween(event.start_date, event.end_date, "day", "[]")) return

        // 無期限開催の場合は一日一回、0時0分にログアウトさせる
        const time = new Date()
        const isMidnight = time.getHours() === 0 && time.getMinutes() === 0

        if (lifecycle._vm.$store.getters["event/event"].is_publish_unlimited && !isMidnight) return

        lifecycle.values.room.close()
        if (lifecycle.values.shareRoom) lifecycle.values.shareRoom.close()
        lifecycle._vm.$store.commit("loading/setLoading", true)
        lifecycle._vm.$store.dispatch("auth/logout")
        clearInterval(expireTimer)
      }, 60000)
    }
  }
}

export default {
  /**
   * ライフサイクル
   * 初期化 => イベント待ち => Disconnect
   * イベント待ちの中でどうするか
   * - イベント待ちが散らかってるよね
   * - イベントの発火口（socketもらばってる）
   * - 画面共有、普通のがあって2種類のPeerをつないでいる
   * - socketのやり取りをclass化する
   *
   * todo リアクティブに変更監視が不要であればlifecycle側のvaluesに移動
   */
  name: "Skyway",
  components: {SkywayLoading, Modal},
  created() {
    this.ready()
  },
  beforeDestroy() {
    lifecycle.disconnect()
  },
  data() {
    return {
      showModal: false,
      sharing: false,
      deviceNotAllowed: false,
      sharePeerId: null,
      grid: null,
      audioOnly: null,
      loading: true,
      pickupStream: {},
      selfStream: {},
      shareStream: {},
      skywayParticipants: [],
      message: {},
      hoverFlags: {
        exit: false,
        sound: false,
        stream: false,
        mute: false,
        share: false
      }
    }
  },
  props: ["type"],
  watch: {
    enableCamera: function() {
      lifecycle.events.updateCamera()
    },
    enableMic: function() {
      lifecycle.events.updateMic()
    },
    sharing: function() {
      if (this.sharing) {
        lifecycle.share()
        lifecycle.events.startShare()
      } else {
        lifecycle.normal()
      }
    },
    skywayParticipants: function() {
      const otherParticipants = this.skywayParticipants.length
      switch (true) {
        case otherParticipants >= 6:
          this.grid = "nineSquares"
          break
        case otherParticipants >= 4:
          this.grid = "sixSquares"
          break
        case otherParticipants >= 2:
          this.grid = "fourSquares"
          break
        case otherParticipants >= 1:
          this.grid = "twoSquares"
          break
        default:
          this.grid = null
      }
    },
    videoDeviceId: function() {
      lifecycle.events.changeDevice()
    },
    micDeviceId: function() {
      lifecycle.events.changeDevice()
    }
  },
  computed: {
    enableCamera: function() {
      return this.$store.getters["stream/enableCamera"]
    },
    enableMic: function() {
      return this.$store.getters["stream/enableMic"]
    },
    user: function() {
      return this.$store.getters["auth/user"]
    },
    videoDeviceList: {
      get: function() {
        return this.$store.getters["device/videoDeviceList"]
      },
      set: function(newValue) {
        this.$store.commit("device/setVideoDeviceList", newValue)
      }
    },
    micDeviceList: {
      get: function() {
        return this.$store.getters["device/micDeviceList"]
      },
      set: function(newValue) {
        this.$store.commit("device/setMicDeviceList", newValue)
      }
    },
    videoDeviceId: {
      get: function() {
        return this.$store.getters["device/videoDeviceId"]
      },
      set: function(newValue) {
        this.$store.commit("device/setVideoDeviceId", newValue)
      }
    },
    micDeviceId: {
      get: function() {
        return this.$store.getters["device/micDeviceId"]
      },
      set: function(newValue) {
        this.$store.commit("device/setMicDeviceId", newValue)
      }
    }
  },
  methods: {
    ready: function() {
      lifecycle.start(this)
    },
    /**
     * 自分以外の全員をミュート
     */
    forceDisableMic: function() {
      lifecycle.socketBroadcast(new MicDisable(), lifecycle.values.room)
    },
    setEnableCamera: function(boolean) {
      this.$store.commit("stream/setEnableCamera", boolean)
    },
    setEnableMic: function(boolean) {
      this.$store.commit("stream/setEnableMic", boolean)
    },
    invertModalStatus() {
      this.showModal = !this.showModal
    },
    mouseOverAction(target) {
      this.hoverFlags[target] = true
    },
    mouseLeaveAction(target) {
      this.hoverFlags[target] = false
    }
  }
}
</script>
